import { createLazyFileRoute } from '@tanstack/react-router';

import { DefaultLayout } from '@src/layout';
import PlatformDocumentsPage from '@src/pages/Platform/Documents';

export const Route = createLazyFileRoute('/platform/documents')({
  component: PlatformDocumentsPageWithLayout,
});

function PlatformDocumentsPageWithLayout() {
  return (
    <DefaultLayout>
      <PlatformDocumentsPage />
    </DefaultLayout>
  );
}
